interface FlagIconProps {
  code: string;
  className?: string;
}

const FlagIcon = ({ code, className = "w-5 h-5" }: FlagIconProps) => {
  const flags: Record<string, JSX.Element> = {
    en: (
      <svg className={className} viewBox="0 0 60 30" xmlns="http://www.w3.org/2000/svg">
        <clipPath id="s"><path d="M0,0 v30 h60 v-30 z"/></clipPath>
        <clipPath id="t"><path d="M30,15 h30 v15 z v15 h-30 z h-30 v-15 z v-15 h30 z"/></clipPath>
        <g clipPath="url(#s)">
          <path d="M0,0 v30 h60 v-30 z" fill="#012169"/>
          <path d="M0,0 L60,30 M60,0 L0,30" stroke="#fff" strokeWidth="6"/>
          <path d="M0,0 L60,30 M60,0 L0,30" clipPath="url(#t)" stroke="#C8102E" strokeWidth="4"/>
          <path d="M30,0 v30 M0,15 h60" stroke="#fff" strokeWidth="10"/>
          <path d="M30,0 v30 M0,15 h60" stroke="#C8102E" strokeWidth="6"/>
        </g>
      </svg>
    ),
    id: (
      <svg className={className} viewBox="0 0 900 600" xmlns="http://www.w3.org/2000/svg">
        <rect width="900" height="300" fill="#FF0000"/>
        <rect width="900" height="300" y="300" fill="#FFF"/>
      </svg>
    ),
    ja: (
      <svg className={className} viewBox="0 0 900 600" xmlns="http://www.w3.org/2000/svg">
        <rect width="900" height="600" fill="#FFF"/>
        <circle cx="450" cy="300" r="180" fill="#BC002D"/>
      </svg>
    ),
    ko: (
      <svg className={className} viewBox="0 0 900 600" xmlns="http://www.w3.org/2000/svg">
        <rect width="900" height="600" fill="#FFF"/>
        <circle cx="450" cy="300" r="120" fill="#C60C30"/>
        <circle cx="450" cy="300" r="80" fill="#003478"/>
      </svg>
    ),
    zh: (
      <svg className={className} viewBox="0 0 900 600" xmlns="http://www.w3.org/2000/svg">
        <rect width="900" height="600" fill="#DE2910"/>
        <polygon points="150,120 180,210 120,150 180,150 120,210" fill="#FFDE00"/>
        <polygon points="240,60 255,90 225,75 255,75 225,90" fill="#FFDE00"/>
        <polygon points="270,120 285,150 255,135 285,135 255,150" fill="#FFDE00"/>
        <polygon points="270,210 285,240 255,225 285,225 255,240" fill="#FFDE00"/>
        <polygon points="240,270 255,300 225,285 255,285 225,300" fill="#FFDE00"/>
      </svg>
    ),
    de: (
      <svg className={className} viewBox="0 0 5 3" xmlns="http://www.w3.org/2000/svg">
        <rect width="5" height="3" fill="#000"/>
        <rect width="5" height="2" y="1" fill="#D00"/>
        <rect width="5" height="1" y="2" fill="#FFCE00"/>
      </svg>
    ),
    fr: (
      <svg className={className} viewBox="0 0 900 600" xmlns="http://www.w3.org/2000/svg">
        <rect width="900" height="600" fill="#FFF"/>
        <rect width="300" height="600" fill="#002395"/>
        <rect width="300" height="600" x="600" fill="#ED2939"/>
      </svg>
    ),
    es: (
      <svg className={className} viewBox="0 0 750 500" xmlns="http://www.w3.org/2000/svg">
        <rect width="750" height="500" fill="#AA151B"/>
        <rect width="750" height="250" y="125" fill="#F1BF00"/>
      </svg>
    ),
  };

  return flags[code] || flags.en;
};

export default FlagIcon;
